import { render, staticRenderFns } from "./TagBeheer.vue?vue&type=template&id=e845e3d2&scoped=true"
import script from "./TagBeheer.vue?vue&type=script&lang=js"
export * from "./TagBeheer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e845e3d2",
  null
  
)

export default component.exports